import { useStyles } from "./LoadingScreen.style";
import { StaticImage } from "../../core/StaticImage/StaticImage";
import Logo from "../../../assets/icons/logo_onmo+_1x.webp";
import Logo2x from "../../../assets/icons/logo_onmo+_2x.webp";
import Logo3x from "../../../assets/icons/logo_onmo+_3x.webp";

import LogoIconTv from "../../../assets/icons/logo_onmo+_tv.webp";
import { isTV } from "../../../utils/platform";

export const LoadingScreen = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {isTV ? (
        <StaticImage
          src={LogoIconTv}
          alt="logo"
          className={classes.logoTv}
        />
      ) : (
        <StaticImage
          src={Logo}
          src2x={Logo2x}
          src3x={Logo3x}
          alt="logo"
          className={classes.logo}
        />
      )}
    </div>
  );
};
